import { Box, Flex, Heading, Text, Tooltip } from "@chakra-ui/react";
import { headingPrimaryFont, headingSecondaryFont, headingTertiaryFont, primaryColor, secondaryColorOne, secondaryColorThree, secondaryColorTwo, secondaryFontSize, smallFontSize } from "../config";
import { Author, ItalicText } from "../components/CustomUtilComponents";
import coulditbeeasy from '../resources/images/coulditbeeasy.png'
import ultimatefreedom from '../resources/images/ultimatefreedom.png'
import reapwhatyousow from '../resources/images/reapwhatyousow.jpeg'
import savesoil from '../resources/images/savesoil.jpeg'
import spreadingjoy from '../resources/images/spreadingjoy.png'
import intelligence from '../resources/images/intelligence.png'
import me from '../resources/images/me.png'
import individualDevelopment from '../resources/images/individual-development.png'
import professionalDevelopment from '../resources/images/professional-development.png'
import blossomIntoInnerFreedom from '../resources/images/blossomintoinnerfreedom.png'
import roopa from '../resources/images/roopa.jpeg'
import manju from '../resources/images/manju.jpeg'
import jagadeesh from '../resources/images/Jagadeesh.jpeg'
import praveen from '../resources/images/praveen.jpeg'
import read from '../resources/images/read.jpeg'
import meditation from '../resources/images/meditation.jpg'
import foodWastage from '../resources/images/foodWastage.jpg'
import suicideprevention from '../resources/images/suicideprevention.png'
import upaYogaImg from '../resources/images/upayoga.jpg'
import suryaShakthiImg from '../resources/images/suryashakthi.jpg'
import angamardhanaImg from '../resources/images/angamardhana_standing.png'
import bhutashudhiImg from '../resources/images/bhutashuddhi.jpg'
import suryaKriyaImg from '../resources/images/suryakriya.jpg'
import yogasanasImg from '../resources/images/yogasanas.jpg'
import hathaSymbolImg from '../resources/images/hathasymbol.jpeg'
import nadaYogaImg from '../resources/images/sanskrit_mantra.jpeg'
import bhakthiYogaImg from '../resources/images/bhakthiYoga.jpg'
import profession from '../resources/images/profession.jpeg'
import { routes } from "./path";
import { ImLinkedin } from "react-icons/im";
import NavigatableIcon from "../components/NavigatableIcon";
import { NavItem_t } from "../components/NavBar/NavBarTypes/NavItem";


export const NAV_ITEMS: Array<NavItem_t> = [
    { label: "Home", href: '/' },

    {
        label: 'Inspiration',
        children: [
            {
                label: 'Isha',
                subLabel: 'Conscious Planet, Save Soil, Rally For Rivers...',
                href: 'https://consciousplanet.org/en',
                target: "_blank"
            },
            {
                label: 'J KrishnaMurti',
                subLabel: 'To free the mind from all conditioning, you must see...',
                href: 'https://www.jkrishnamurti.org/',
                target: "_blank"
            },
        ],
    },
    {
        label: 'Learn *',
         href: '/learn',
        children: [
            {
                label: 'Yoga',
                subLabel: 'A State of Being...',
                href: routes.yoga,
            },
            {
                label: 'Physical Fitness',
                subLabel: 'Move freely. Live fully.',
                href: routes.hathaYoga,
            },
            {
                label: 'Music',
                subLabel: 'Sound is An Experience',
                href: routes.nadaYoga,
            },
            {
                label: 'Library',
                subLabel: 'Books are a great companion...',
                href: '/learn/library',
            },
            // {
            //     label: 'Of Age Learning Center',
            //     subLabel: 'Does Learning ever end?',
            //     href: '/#',
            // },
            // {
            //     label: 'Software Engineering',
            //     subLabel: 'Intern, Volunteer',
            //     href: '/softwaresystems',
            // },
            // {
            //     label: 'Home School (Coming soon...)',
            //     subLabel: 'The way of life...',
            //     href: '/homeschool',
            // },
            // {
            //     label: 'Yoga',
            //     subLabel: 'Hatha Yoga, Dialogues, Coming Soon!',
            //     href: '#',
            // },

            // {
            //     label: 'Tutorials',
            //     subLabel: 'Academic Support',
            //     href: '#',
            // },
            // {
            //     label: 'Languages',
            //     subLabel: 'Coming Soon!',
            //     href: '#',
            // },
            // {
            //     label: 'Science & Arts',
            //     subLabel: 'Instruments, Dance & ...',
            //     href: '#',
            // },
            // {
            //     label: 'Essentials',
            //     subLabel: 'WoodWorking',
            //     href: '#',
            // },
            // {
            //     label: 'See more',
            //     subLabel: "Coming soon!",
            //     // 'Library, Tutorials, Science & Arts, Wood working'
            //     href: '#',
            // },
        ],
    },
    // {
    //     label: 'Join Us',
    //     href: '#',
    //     children: [
    //         {
    //             label: 'Club',
    //             subLabel: 'Children, Adult, Retired, we all can learn! Coming Soon',
    //             href: '#',
    //         },
    //         {
    //             label: 'Volunteer',
    //             subLabel: 'Be in touch with community; in other word Life! Coming Soon',
    //             href: '#',
    //         },
    //         {
    //             label: 'Upcoming Events',
    //             subLabel: 'Explore and Join us for a day! Coming Soon',
    //             href: '#',
    //         },
    //         {
    //             label: 'Join the cause',
    //             subLabel: 'What do you care about? Coming Soon',
    //             href: '#',
    //         },
    //     ],
    // },
    // {
    //     label: 'Give Back',
    //     href: '#',
    //     children: [
    //         {
    //             label: 'Our Services',
    //             // Event Management
    //             subLabel: 'What we do to align with our values... Coming Soon',
    //             href: '#',
    //         },
    //         {
    //             label: 'Donate',
    //             subLabel: 'Time or Money, Ideas or Resource, any difference? Coming Soon',
    //             href: '#',
    //         },
    //     ],
    // },
    {
        label: "Activities",
        href: "/activities",
        children: [
            // {
            //     label: "Our Life",
            //     subLabel: "is the work we do! coming soon...",
            //     href: '/initiatives',
            // }
            {
                label: 'U2L',
                subLabel: 'From Parents To Children By the Community...',
                href: routes.u2l,
            },
            {
                label: 'Professional Development',
                subLabel: 'Moving on from Labour to Profession...',
                href: routes.pdSupport,
            },
        ]
    },
    {
        label: 'Blog',
        href: '/blog',
        children: [
            {
                label: 'SwaDharma Spandana',
                subLabel: 'What, Why, How, Who? Know Us!',
                href: '/blog',
            },
            {
                label: 'Our Experiences',
                subLabel: 'Events, News Letters Coming Soon',
                href: '/blog/our-experiences',
            },
            // {
            //     label: 'The Way of Life',
            //     subLabel: 'beyond physilogy & psychology',
            //     href: '/blog/way-of-life',
            // },
            {
                label: 'Team',
                subLabel: 'behind Swadharma Spandana',
                href: '/blog/team-members',
            },
        ],
    }
]

const visionOneArticle = <>
    <Text color={"black"}>
        There's a lot of talk in the town drawing parallel between Avatars of Deity Vishnu from scriptures and Darwin’s evolutionary theory,
        are they one and the same? nobody can dictate one's opinion of this on another but if at all anyone's little familiar with both
        of them, the difference in the extent of existentiality each addresses is as striking as day and night. While Darwin goes on to
        say how one’s body evolved from single cell to monkey and a man, he misses out on a crucial questions like how and why! Also little
        or no addressing of anything other than physical appearance; while the former seems like a fairy tale, it advertises extraordinary
        sense of depth and understanding of the process of life in its entirety, something beyond the physical.
    </Text>

    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        The story delicately addresses how the journey of life begins under the servitude of elements,
        bound by the rules of of nature, with various analogies such as fish being bound to the water and unfolds the journey on how
        life traverses through the barrier of multitude of elements, from a amphibian tortoise to a terrestrial boar and apparently surfacing
        something subtle that is unbounded by the nature, bit by bit, step by step; Instincts (Vasanas), that can be calmed by commitment
        and devotion (Narasimha - Lion). The thought and intellect that can scale the three worlds in other words life, death
        and beyond (Vamana), and it goes on talking about focus, dedication, discrimination (parashurama) the qualitative aspects of life.
        These qualitative aspects of life narrated in these stories nudges one towards existential reality of awareness that starts to illuminate
        one’s true nature as historical figures like Rama, Krishna showcased.
        Their life is the epitome of Intelligence, unbridled love and joy beyond reasons, and gently, subtly surfacing the jewel of freedom as Buddhas,
        leading towards the true nature of life beyond elemental play described as kalki, mystic, consciousness or god, a mere word can’t do justice!
    </Text>
    <br />

    <Text>
        In different times, different predominant human qualities are revered, true given the time is subjective in human consciousness its
        never the same for two individuals but if we look at the current sate of the society, its clearly in a cusp of non physical. The brain,
        Intelligence is more appreciated and playing crucial role than brawn ever did and understanding its evolution has become the paramount.
        True human evolution is complete as per Darwin’s theory but People and time has shown us again and again that there is room for human,
        brain to evolve from Having; Doing to Being.
    </Text>

    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp;
        It took enormous, unimaginable time and unknown effort to be in state we are in this existence, yet we don’t know a single fact that’s
        complete, whole about the existence. We don’t understand a single life on this planet in its entirety, not even oneself! But in every
        point of time there was, there is a presence who have always declared that there will be the presence, comprehending the whole, showcasing
        the possibility beyond fragmentary nature to one's who are stuck. In this and many culture it was predominantly established that the humanity
        in itself is a blueprint of the existence, understanding oneself is put forth as ultimate possibility and the journey starts from having.
    </Text>
    <br />

    <Text>
        Having reached the point where one can exercise intellect, giving the taste of “will”, we are compelled to explore that “will” more and
        more in the field of human consciousness. Though it’s the outer most layer, “having” is the quality that gives one the taste of the “will”,
        the “I”, if we dare name!
    </Text>

    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp; &nbsp;
        Having impels satisfaction, that I have food, I have home, I have husband/wife, I have security etc, etc but that’s as far as it goes. Once
        the satisfaction is tasted, the focus seamlessly shifts to the factor “Doing”, that enabled one to taste the satisfaction. The intricate
        relation between doing and having is illuminated.
    </Text>
    <br />

    <Text>
        As it can be seen throughout out the history scientists, athletes, musicians, artists, writers, without much concern for what they had always
        found satisfaction in what they did, as doing implies freedom, “HAVING” Freedom, “HAVING” Satisfaction! But the origin of the action is in
        itself rooted in the physicality! And science is yet to discover perpetual energy! So there is no wholeness of truth in action, only a taste
        of it, fragment of it, but not whole. When this fact grips one entirely is when one starts to wonder who’s the doer of all the
        doings? Who’s the experiencer experiencing the actions, freedom to act and occasional seeming satisfaction that accompanies the following?
    </Text>
    <br />
    <Text textAlign={"center"}>Who am I?</Text>
    <br />
    <Text>
        If I am the doer, if I have t the freedom that lets me experience satisfaction within, then what’s the need to do, can’t I just be?
        Be in the state of experience? With these deeper questioning, suddenly all the outer layer seems like a sham.
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp;
        If one can’t be in a state of experience one wants irrespective of situations, time etc, etc, is it freedom? Without freedom can one really
        do what one wants? Without being able to do what one wants can there be satisfaction? The taste of the things that led one to the question,
        themselves are shattered by the question, like the ground beneath one's feet crumbling into abyss, hurtling one into the free fall of nowhere,
        but in that land of pain there are glimpses of the being, the taste of fulfillment, foundation of all the other states but that’s just a glimpse!
        Like the taste of initial satisfaction and freedom, what’s beyond?
    </Text>
    <br />

    <Text>
        Different times named it differently god, ram, krishna, christ, consciousness etc, etc but the longing and the evolution towards it never died
        out. This is a conscious attempt for human evolution, ultimate possibility of being.
    </Text>
    <br />
    <ItalicText color={secondaryColorTwo}>
        <Text textAlign={"center"}>
            Moment of Satisfaction begot <br />
            taste of Having, <br />
            Moment of Freedom begot <br />
            the taste of Doing <br />
            Moment of Fulfillment begot <br />
            the taste of being <br />
            & all that's left is the longing, <br />
            longing for the beyond!
        </Text>
    </ItalicText>
</>

const visionTwoArticle = <>

    <Text textAlign={"center"}> Can Artificial Intelligence ever be held accountable?</Text>
    <br />
    <Text>
        This is the question of the century. Though it’s not denied, it's also not accepted that Artificial Intelligence can be held accountable.
        I mean how can humans ever answer that, when we still are hesitant to assume responsibility for our own mess!
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        Pun aside, there may be a lot of conflicting opinions on the whole state of affairs but it has made one thing clear, the difference between
        intellect and intelligence. In crude terms  the only capability of AI is applying logic of “if”, “else If” and “else” on the given data
        and establishing the patterns by processing the memory of past to act in present, in reality; The present and the reality that coincidentally
        if not audaciously, refuses to fit in any pattern.
    </Text>
    <br />

    <Text>
        After millennium humanity is yet to discover the boundary of the universe and as if mockingly throwing cold water on an attempt, it seems like
        universe is ever expanding, as it expands birthing possibilities, scenarios, if, else’s; so will it be ever possible to contain ever expanding,
        seeming living entity that’s growing into patterns?
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        How can the memory, memory of the patterns be held responsible when it can’t keep up with the ever growing possibilities? The era of AI has laid
        it bare on the table that bundle of memories, intellect can only be utilized but can never be held accountable! But also begs the question
        on the nature  of the utilizer of the intellect! If we can call it intelligence.
    </Text>
    <br />

    <Text>
        Human brain storage capacity is still in question, replication of human memory management is yet to be achieved;&nbsp;
        <Box as="a" href="https://www.tomshardware.com/tech-industry/full-scan-of-1-cubic-millimeter-of-brain-tissue-took-14-petabytes-of-data-equivalent-to-14000-full-length-4k-movies"
            color={secondaryColorTwo}
            _hover={{
                color: "blue",
            }}
            target="blank">
            with partial mimicking
        </Box>  its unsustainable but with deeper and deeper understanding of the nature of brain one can realize that there is memory and then there
        is living, growing, unnamable entity that’s not a pattern, not a memory, ever growing, ever expanding, like the unfathomable universe!
    </Text>
    <br />
    <Text>
        If the nature of universe is truly “uni” - versa; one and not two or three, timeless in nature without the beginning and the end!
        The intelligence that ever expands, the intelligence utilizing the intellect; doesn’t that mean human intelligence is universal in nature?!
        But what is the nature of this seemingly timeless intelligence unbounded by the contradiction of time, now and then, Here and there,
        Life and death?
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        As a possibility put forth by the time itself, if at all there’s such a timeless intelligence beyond memory and thought that can only
        be rediscovered!
    </Text>
    <br />
    <Text textAlign={"center"} >Which already exists! </Text>
    <br />
    <Text>
        Isn’t this the greatest, most appropriate time, when AI is understood, when intellect is at its peak and  sharpest,
        to embark on this journey?!
    </Text>
</>

const visionThreeArticle = <>
    <Text>
        Even when all the  conditions are set and human intellect is functioning on its peak in know human history, we are struggling, isn’t it
        important to look at why we are struggling? Struggling ethically, mentally, in turn causing physical struggles that can be taken care of
        with right care and attention!
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        Societal status, jobs, insurance, security, has become paramount importance! Cyber bulling, mental illness, abnormal societal standards,
        suicide has become norm! Isn’t this the ripe time to take a fresh look at where we are heading towards? Why we are struggling even when
        we think we are collectively functioning at our highest possibility?
    </Text>
    <br />
    <Text>
        At the least some of us, before the explosion of digital technology, in childhood didn’t we live our days without any burdens dragging us down?
        Eating what ever our mother’s cooked, playing whenever situation allowed and resting without the thought of tomorrow; so what changed?
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        Sure responsibility grew but wasn’t that why we were educated, to deal with them in a finer possible manner and be joyful? But even after
        eighteen years of formal education why are we struggling with survival aspects like food, clothes, sheltering, insurances, job money,
        everything that was created by humans; why are we held back by the very things created by humans to propel us forward?  Was it really worth
        spending eighteen years of one’s life over things that fills one with more fear? More restrictions? Curbing freedom everyone born with?
    </Text>
    <br />
    <Text color={secondaryColorTwo} textAlign={"center"}>Is our education really what it should be?</Text>
    <br />
    <Text>
        We never questioned our identities and blindly accepted someone else’s idea of who we are, name given by parents, status given by society and
        in a way by time, which in itself is ever changing!
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        No wonder the anxiety, stress and desperation is pestering in preserving, protecting and guarding the boundaries that forms one’s identities,
        while the time rips it apart bringing the dread of an end, the death, but when we actually look at it do we even know who was born,
        who is living, who will be that's dying and who is this even uttering the syllable “I” ?
    </Text>
    <br />
    <Text>
        Is it intelligent to be in the grasp of fear without even knowing the nature of the fear or oneself? Is one’s time really worth the education
        that subjects one to various fears, and sufferings? Is it still relevant to the time we are in? Or should we be taking a fresh look at what we
        call as “I”, what we think is the “education” and “life”?
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        Isn’t it worth creating an ambience and situations where we can collectively explore the true nature of life beyond the societal norms?
        beyond the relics of the past?!
    </Text>
    <br />
    <Text>
        Does one’s education truly ends after earning a paper? Is learning only meant for putting a bread on the table and be in the dread of the
        unknown forever?
        Aren’t these questions worth acted at? Looked at?
    </Text>
</>

const missionOneArtice = <>
    <Text>
        The education in western countries has evolved and skills such as carpentry, cooking, archery, swimming etc are part of the curriculum
        but why are we stuck in our mediocre idea of modern western education?
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp;
        The western education is steadily going back to the template of traditional Indian education system baring the ignorance of why it was so in our culture;
        they think it's their invention.
    </Text>
    <br />

    <Text>
        Anyway, these essential skills are so valued and ingrained in the current western societal structure that they are treated equal to any other profession.
        In fact most tend to learn and do it on their own rather than spending a hefty price in it, but why are we stuck in our prejudice that being employed is
        the only respectable profession?
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp;
        Looking back at our history and heritage if we observe carefully it is pleanty evident that what flourished and made our culture, country great was the
        Entrepreneurial attitude, micro, distributed markets and economy flourishing in the melting pot of diversity,
        in contrast to the capitalism we are heading towards.
    </Text>
    <br />

    <Text>
        The generation of population in urban has almost no insight on any of the things other than academics, job hunt, living pay check to pay check, indulging
        in weekend parties and receding capability to handle stress, challenges and disruption.
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp;
        To speak of my own experience I never found the academic rat race exciting, in fact it was unnecessary pressure, but got through it till masters with
        attitude that I don't have any other choice. Even now after having a lot of exposure to various things and mustering up courage to step outside
        of the social norm, all i have faced is failures.
    </Text>
    <br />
    <Text>

        Failures in various dimensions such as emotional, societal etc., True one can't succeed in a single try or with breeze but then why has it been made
        such that failure is the end of life? why does our society measures success or failure in comparison to others? or sets a standard on what success or failure
        is?
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp;
        Why is our society not inclusive of failure in its structure but rather exclusive, absuvie of failures, making individuals dare not even to try?
        If the so called society, collective human consciousness smothers creativity and love on each and every step how can we and our future generation have
        well being while dancing on the palms of few corporate gaints pre occupied, obsessed with their own limitations, limited idea of well being?
    </Text>
    <br />

    <Text>
        Youth, child suicide rate due to academic pressure, unemployment, relationship failure is proliferating! why are they feeling abandoned?
        why is it ending life or mediocre life would even seem like an option?
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp;
        isn't society meant to be inclusive? having place for every kind of unique life rather than serving single interest?
    </Text>
    <br />

    <Text color={secondaryColorTwo}>
        This is an attempt to envision and take a step towards inclusive, learning environment for individuals, an attempt to explore life individually,
        totally with everyone an attempt towards true melting pot of diversity.
    </Text>
</>

const missionTwoArticle = (<>
    <Text>
        In japan, KFC a fast food chain brand has been made synonymous with christmas itself, "Kentucky is Christmas" they say, and for a matter of fact
        every one knows its not! well at least the generations before KFC's establishment and its raise in popularity are aware of the fact, but the younger
        generation does actually think Kentucky is Christmas! not Jesus Christ but Kentucky is!
    </Text>
    <Text textAlign={"center"} color={secondaryColorTwo}>
        How did it come to this?!
    </Text>
    <Text textAlign={"center"}>
        Isn't it the same as how we came to believe money, car, house etc etc is happiness?
    </Text>
    <br />

    <Text>
        Its a simple observation, that thought, emotion, feelings and of course happiness originates from within but most of us are convinced that it is
        something to be chased after rather than looked at, or be with what already is. Sure its not a matter of one can or can't, want or don’t, one's capable or not but the conglomeration of situations and the amalgamation of boundaries;
        of course physical boundaries of various kinds but mostly psychological.
    </Text>
    <br />

    <Text>
        Only a man who doesn't know hunger is capable of preaching to a person dying of hunger, and treating food like a commodity.
    </Text>


    <Box display={"flex"} flexDir={{ base: "column", md: "row" }} justifyContent={"space-evenly"}>
        <Box display={"flex"} flexDirection={"column"} height={{ base: "18rem" }} width={{ base: "full", md: "15rem", lg: "20rem" }}
            cursor={"pointer"} as="a"
            href={"https://www.unep.org/news-and-stories/press-release/world-squanders-over-1-billion-meals-day-un-report"}
            target="_blank">
            <Box height={{ base: "15rem" }} width={"full"}
                backgroundImage={foodWastage}
                backgroundSize={"30rem"}
                bgPos={"50%"}
                backgroundRepeat={"no-repeat"}
                textAlign={"center"}
            />
            <Box textAlign={"center"}>How much Food we waste?</Box>
        </Box>

        <Box display={"flex"} flexDirection={"column"} height={{ base: "18rem" }} width={{ base: "full", md: "15rem", lg: "20rem" }}
            cursor={"pointer"} as="a"
            href={"https://www.who.int/news-room/fact-sheets/detail/suicide"}
            target="_blank">
            <Box height={{ base: "15rem" }} width={"full"}
                backgroundImage={suicideprevention}
                backgroundSize={"18rem"}
                bgPos={"50%"}
                backgroundRepeat={"no-repeat"}
                textAlign={"center"}
            />
            <Box textAlign={"center"}>How many are killing oneself?</Box>
        </Box>
    </Box>

    <Text>
        Only a man deprived of clarity can think there can be fulfillment in division and walling up inside one's psychological structure and identities.
        Only a man who doesn't know the joy of life can be trapped in the pressure of education, pleasure, and pain of capitalism.
    </Text>
    <br />
    <Text textAlign={"center"} color={secondaryColorTwo}>
        Only a man who is not aware of one who draws this breath can be afraid of death
    </Text>
    <br />
    <Text>
        The fulfillment of of life lies in addressing these situation not as a part but as a whole in whatever the capacity possible subjective
        to time, doesn’t it?
    </Text>
    <br />
    <Box as='i' textAlign={"center"} color={secondaryColorTwo}>
        <Text>
            Sun burns for naught,<br />
            yet is a reason for life; <br />
            Wind blows with no obligation,<br />
            yet life breaths into ecstasy; <br />
            Water flows with no agenda,<br />
            yet merges & becomes everything; <br />
            The Worm needs no harvest,<br />
            yet ploughs the soil; <br />
            Flowers possess no fragrance,<br />
            yet blooms; <br />
            <br />
            When everything are in action, inclusive of existence; <br />
            what else, &quot;action of self&quot; can be?
        </Text>
    </Box>
</>)

const missionThreeArticle = (<>
    <Text textAlign={"center"} color={secondaryColorTwo}>
        The saturation of having, the limitation of doing, without them how can one arrive to seek the being?
    </Text>
    <br />

    <Text>
        There's an order to everything unless its true nature is experienced in whole, which is always cyclical. Once the cyclical nature of a process
        is in experience, the order which seemed like a logical explanation and understanding feels like a farce!
    </Text>
    <br />

    <Text>
        It's like knowing the truth that there can't be water without rain unless one enquires the nature of the process of the rain.
        Once the whole process of water cycle is in perception the truth that rain is source of water falls apart but would it make rain being a source of
        water a lie? Does it?
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp;
        Though it doesn't, it also makes one thing apparent, that the rain being the medium is not the origin! Our understanding of the source was mere
        expression of the origin that lays uninquired, unseen, waiting to be uncovered and experienced.
    </Text>
    <br />

    <Text textAlign={"center"} color={secondaryColorTwo}>
        The happiness of having, a mere expression of the source isn't a lie, but is it the origin?
    </Text>
    <br />

    <Text wordBreak={"break-word"} overflowWrap={"break-word"} >
        Having tasted the expression isn't the science and advancement means knowing its origin within oneself?
        <br /> <br />
        Like tracing the flow of the water, which illuminates the nature of the cycle when its destination is discovered;
        Our mission is, doing what's necessary to set the stage and create the ambiance for more and more people to see beyond
        <Box color={secondaryColorOne}
            fontWeight={'bold'}
            as={'a'} href="/blog?id=vision_one"> "Having"</Box>
        and join together in a journey to explore life in its totality to deepen the perception on the the cycle of life and death!
    </Text>
    <br />

    <Text>
        Though our "ithihasa", the rich history, which seem like mixture of many things, in all its essence is just an attempt to convey a single fact;
        To put it in words relevant to today's world by borrowing the words of swami vivekananda,
    </Text>
    <br />
    <Text textAlign={"center"} color={secondaryColorTwo}>
        "The advancement of human civilization is not in hoarding material wealth  <br />
        or congregating in the concrete cities, closed of to the nature, and living foolish life <br />
        but in understanding the human senses, perception <br />
        and reaching the epitome of understanding <br />
        or rather<br />
        in experiencing this phenomenon we call life or truth." <br />
    </Text>
    <br />

    <Text textAlign={"center"}>
        The drawer of this breath, the ultimate expression of existence, the origin;  isn't that a joy?
    </Text>
    {/* (links to old age home & support, retirement activities - teaching, gardening, cooking? supporting others? etc etc) */}
</>)


const visionBlogHref = {
    one: "/blog?id=vision_one",
    two: "/blog?id=vision_two",
    three: "/blog?id=vision_three"
}
const missionBlogHref = {
    one: "/blog?id=mission_one",
    two: "/blog?id=mission_two",
    three: "/blog?id=mission_three"
}

const libraryHref = {
    one: "/blog?id=library_one",
    two: "/blog?id=library_two",
    three: "/blog?id=library_three"
}

const yogaHref = {
    one: "/blog?id=yoga_one",
}

const visionBlogTitle = {
    one: "Having Doing Being!",
    two: "Intelligence Amid AI!",
    three: "Survival To Creative!"
}
const missionBlogTitle = {
    one: "Nurturing Life Beyond Ideas!",
    two: "Action OF Self!",
    three: "Spreading JoY"
}

const libraryBlogTitle = {
    one: "Why Read?!"
}

const yogaBlogTitle = {
    one: "Why Yoga?!",
}

const visionOne = {
    "id": "one",
    "groupId": "vision",
    "title": visionBlogTitle.one,
    "image": ultimatefreedom,
    "imageAlt": "ultimate freedom    Image source: https://www.instagram.com/isha.foundation/",
    "body": {
        "title": "From Having To Doing To Being",
        "content": visionOneArticle,
        "shortContent": "In different times, different predominant human qualities were revered, given the time is subjective in human consciousness..."
    },
    "footer": "Being?",
    "isArticle": false,
    "isInitiallyOpen": false,
    "href": visionBlogHref.one,
    "next": {
        "href": visionBlogHref.two,
        "title": "Intelligence Amid AI!"
    },
}

const visionTwo = {
    "id": "two",
    "groupId": "vision",
    "title": visionBlogTitle.two,
    "image": intelligence,
    "imageAlt": "unlocking life    Image source: https://www.instagram.com/isha.foundation/",
    "body": {
        "title": "In Era of AI Seeking Intelligence of Being",
        "content": visionTwoArticle,
        "shortContent": "The era of AI has laid it bare on the table that bundle of memories, intellect can only be utilized but can never be held accountable..."
    },
    "footer": "What?",
    "isArticle": false,
    "isInitiallyOpen": false,
    "href": visionBlogHref.two,
    "previous": {
        "href": visionBlogHref.one,
        "title": visionOne.title
    },
    "next": {
        "href": visionBlogHref.three,
        "title": visionBlogTitle.three
    }
}

const visionThree = {
    "id": "three",
    "groupId": "vision",
    "title": "Survival To Creative!",
    "image": coulditbeeasy,
    "imageAlt": "could it be easy to know? Image source: https://www.instagram.com/isha.foundation/",
    "body": {
        "title": "Survival Orientation To Creative Conscious Living",
        "content": visionThreeArticle,
        "shortContent": "Is it intelligent to be in the grasp of fear without even knowing the nature of the fear or oneself? Is one’s time really worth the education that subjects..."
    },
    "footer": "How?",
    "isArticle": false,
    "isInitiallyOpen": false,
    "href": visionBlogHref.three,
    "previous": {
        "href": visionBlogHref.two,
        "title": visionBlogTitle.two
    },
    "next": {
        "href": missionBlogHref.one,
        "title": missionBlogTitle.one
    }
}


const missionOne = {
    "id": "one",
    "groupId": "mission",
    "title": missionBlogTitle.one,
    "image": reapwhatyousow,
    "imageAlt": "reap what you sow Image source: https://www.instagram.com/isha.foundation/",
    "body": {
        "title": "Community to nurture Life In Existentiality",
        "content": missionOneArtice,
        "shortContent": "Looking back at our history & Heritage, the entrepreneurial attitude, micro, distributed markets & economy flourished  in the melting pot of diversity, in contrast to the capitalism...."
    },
    "footer": "How?",
    "isArticle": false,
    "isInitiallyOpen": false,
    "href": missionBlogHref.one,
    "previous": {
        "href": visionBlogHref.three,
        "title": visionBlogTitle.three
    },
    "next": {
        "href": missionBlogHref.two,
        "title": missionBlogTitle.two
    }
}

const missionTwo = {
    "id": "two",
    "groupId": "mission",
    "title": missionBlogTitle.two,
    "image": savesoil,
    "imageAlt": "save soil Image source: https://www.instagram.com/isha.foundation/",
    "body": {
        "title": "Doing What Really Matters To Oneself & Life Around",
        "content": missionTwoArticle,
        "shortContent": "Only a Person who don't know hunger is capable of treating food as a commodity, only a man without clarity can imagine fulfillment in division..."
    },
    "footer": "What?",
    "isArticle": false,
    "isInitiallyOpen": false,
    "href": missionBlogHref.two,
    "previous": {
        "href": missionBlogHref.one,
        "title": missionBlogTitle.one
    },
    "next": {
        "href": missionBlogHref.three,
        "title": missionBlogTitle.three
    }
}

const missionThree = {
    "id": "three",
    "groupId": "mission",
    "title": missionBlogTitle.three,
    "image": spreadingjoy,
    "imageAlt": "spreading joy Image source: https://www.instagram.com/isha.foundation/",
    "body": {
        "title": "Discovering the JoY of Being",
        "content": missionThreeArticle,
        "shortContent": "Doing what's needed to set the stage and create the ambiance to go beyond having; towards exploration of life in its totality to ..."
    },
    "footer": "Being?",
    "isArticle": false,
    "isInitiallyOpen": false,
    "href": missionBlogHref.three,
    "previous": {
        "href": missionBlogHref.two,
        "title": missionBlogTitle.two
    },
    "next": {
        "href": libraryHref.one,
        "title": libraryBlogTitle.one
    }
}

const hathaYogaShortContent = (<Box>
    The body is a very large part of who you are right now.
    The science of using the body to hasten one&apos;s evolutionary process is hatha yoga.
    Health and fitness are just the side-benefits of Hatha Yoga.
    Classical Hatha Yoga is a powerful system to prepare the system to explore our full potential.
</Box>)

const hataYoga = {
    "id": "hata-yoga",
    "groupId": "paths-to-yoga",
    "title": "Hatha Yoga",
    "image": hathaSymbolImg,
    "imageAlt": "Hatha Yoga Symbol    Image source: https://www.instagram.com/isha.foundation/",
    "body": {
        "title": "Ha Sun; tha Moon",
        "content": "",
        "shortContent": hathaYogaShortContent
    },
    "footer": "Learn",
    "isArticle": false,
    "isInitiallyOpen": false,
    "href": "/learn/yoga/hatha-yoga",
}

const nadaYoga = {
    "id": "nada-yoga",
    "groupId": "paths-to-yoga",
    "title": "Nada Yoga",
    "image": nadaYogaImg,
    "imageAlt": "Nada Yoga    Image source: unknown",
    "body": {
        "title": "In the beginning was the Word, and the Word was with God, and the Word was God.",
        "content": "Coming soon...",
        "shortContent": `Sound has an impact on both the body and the mind. 
        A mantra is a mathematically organized sound pattern that has a deep impact on the system. 
        One can break through limitations in so many different ways just by uttering certain mantras.`
    },
    "footer": "Chant",
    "isArticle": false,
    "isInitiallyOpen": false,
    "href": "/learn/yoga/nada-yoga"
}

const bhakthiYoga = {
    "id": "bhakthi-yoga",
    "groupId": "paths-to-yoga",
    "title": "Bhakthi Yoga",
    "image": bhakthiYogaImg,
    "imageAlt": "Bhakthi Yoga    Image source: unknown",
    "body": {
        "title": "Using intensity of emotion for transcendence",
        "content": "Coming soon...",
        "shortContent": `The only thing is, emotion can take different forms. It can take very sweet and wonderful forms, 
        it can take absolutely nasty and horrendous forms. The thing is to train it to take a sweet and beautiful
        form. Devotion is a way of transforming your emotion from negativity to pleasantness.`
    },
    "footer": "Become",
    "isArticle": false,
    "isInitiallyOpen": false,
    "href": "/learn/yoga/bhakthi-yoga"
}

const hataYogaUpaYoga = {
    "id": "upa-yoga",
    "groupId": "hatha-yoga-beginner",
    "title": "UpaYoga",
    "image": upaYogaImg,
    "imageAlt": "UpaYoga    Image source: https://www.instagram.com/isha.foundation/",
    "body": {
        "title": "A Start Line...",
        "content": ``,
        "shortContent": `Upa Yoga, a powerful practice which activates the physical, psychological 
        and energy dimensions of a human being,
        allowing one to live a complete physical life. It is best for casual practitioners seeking
        higher levels of physical and psychological wellbeing."`
    },
    "footer": "",
    "isArticle": false,
    "isInitiallyOpen": false,
    "href": visionBlogHref.one,
}

const hataYogaSuryaShakti = {
    "id": "surya-shakti",
    "groupId": "hata-yoga-beginner",
    "title": "Surya Shakti",
    "image": suryaShakthiImg,
    "imageAlt": "Surya Shakti    Image source: https://www.instagram.com/isha.foundation/",
    "body": {
        "title": "Gratitude to the Source...",
        "content": "Coming soon...",
        "shortContent": `A human being is ill only because he does not know how to be still.
        if one has to be still, they must have a good strong spine otherwise they can't. Surya Shakti is
        a complete process which strengthens the spine and the various aspects of the body such as the muscles, 
        tendons, ligaments joints, and the internal organs.`
    },
    "footer": "",
    "isArticle": false,
    "isInitiallyOpen": false,
    "href": visionBlogHref.one,
}

const hataYogaAngamardhana = {
    "id": "angamardhana",
    "groupId": "hata-yoga-beginner",
    "title": "Angamardhana",
    "image": angamardhanaImg,
    "imageAlt": "Angamardhana    Image source: https://www.instagram.com/isha.foundation/",
    "body": {
        "title": "Mastering the Limbs, Physically and Mentally...",
        "content": "Coming soon...",
        "shortContent": `The word “Angamardana” means to have mastery over your limbs or body parts. 
        Whatever action you want to perform in this world, how much mastery you have over your 
        limbs determines how well you are going to do it.
        Even if you just look at it as an exercise form, Angamardana will definitely pass the test.
        But strengthening the muscle and bringing fat levels down are just fringe benefits. 
        The important thing about whatever sadhana you are doing, whether it is Angamardana or anything else,
        is that we are trying to work up the energy system to a certain level of energy and integrity of energy.`
    },
    "footer": "",
    "isArticle": false,
    "isInitiallyOpen": false,
    "href": visionBlogHref.one
}

const hataYogaBhutaShudhi = {
    "id": "bhutashudhi",
    "groupId": "hatha-yoga-advanced",
    "title": "Bhuta Shudhi",
    "image": bhutashudhiImg,
    "imageAlt": "Bhuta Shudhi    Image source: https://www.instagram.com/isha.foundation/",
    "body": {
        "title": "Knowing the source...",
        "content": "Coming soon...",
        "shortContent": `The basis for all creation, including the physical body, is the group of five elements,
        earth, water, wind, fire, and space. The wellbeing of the body and mind can be established by purifying
        these five elements within the human system. This process also shapes the body into a stepping stone 
        towards one’s ultimate wellbeing.`
    },
    "footer": "",
    "isArticle": false,
    "isInitiallyOpen": false,
    "href": visionBlogHref.one,
}

const hataYogaSuryaKriya = {
    "id": "surya-kriya",
    "groupId": "hata-yoga-advanced",
    "title": "Surya Kriya",
    "image": suryaKriyaImg,
    "imageAlt": "Surya Kriya    Image source: https://www.instagram.com/isha.foundation/",
    "body": {
        "title": "Intimacy with the source...",
        "content": "Coming soon...",
        "shortContent": `Surya Kriya is the fundamental practice and a powerful process of activating the sun within us. 
        This is a refined process that needs enormous attention in terms of the geometry of the body.
        Surya Kriya has more spiritual intentions and more powerful connotations attached to it which need to be
        taught carefully and learnt with a certain level of involvement.`
    },
    "footer": "",
    "isArticle": false,
    "isInitiallyOpen": false,
    "href": visionBlogHref.one,
}

const hataYogaYogasanas = {
    "id": "yogasanas",
    "groupId": "hata-yoga-advanced",
    "title": "Yogasanas",
    "image": yogasanasImg,
    "imageAlt": "Yogasanas    Image source: https://www.instagram.com/isha.foundation/",
    "body": {
        "title": "Becoming the source...",
        "content": "Coming soon...",
        "shortContent": `Yoga is about creating a union between these two dimensions – inner and outer,
        you and the rest, you and the other. When there is no “you” and “the other,” when there is just
        “you” and “you,” that is yoga. Asanas are a physical form of approaching this ultimate union,
        because the physical body is the easiest thing to work with.`
    },
    "footer": "",
    "isArticle": false,
    "isInitiallyOpen": false,
    "href": visionBlogHref.one
}



export const visionCards = [visionOne, visionTwo, visionThree]
export const missionCards = [missionOne, missionTwo, missionThree]
export const hataYogaBeginnerCards = [hataYogaUpaYoga, hataYogaAngamardhana, hataYogaSuryaShakti]
export const hataYogaAdvancedCards = [hataYogaBhutaShudhi, hataYogaSuryaKriya, hataYogaYogasanas]
export const pathsToYogaCards = [hataYoga, nadaYoga, bhakthiYoga]

export const mainPageIntroduction = (<Box
    width={{ base: "100%", lg: "40vw" }}
    maxW={{ base: "100%", lg: "50rem" }}

>



    <Text fontSize={headingPrimaryFont} color={primaryColor}>Swa Dharma Spandana</Text>
    <Flex justifyContent={"right"}>
        <Text mr={1} fontSize={headingTertiaryFont} color={primaryColor}>The </Text>
        <Text mr={1} fontSize={headingTertiaryFont} color={secondaryColorTwo}>Resonance </Text>
        <Text fontSize={headingTertiaryFont} color={primaryColor}>of Self</Text>
    </Flex>
    <br />
    <Box textAlign={"justify"} color={secondaryColorTwo} >
        <Text>
            Two generations ago a picture of a family would be that of a honeycomb;
            today it’s a struggle to trust anyone! and consequences are innumerable
            but one that needs imminent attention is mental health crisis individuals
            are struggling through in various levels.
        </Text>

        <Text>
            &nbsp; &nbsp; &nbsp; &nbsp; From joint family to suicide due to loneliness, stress
            and fear of failures; From caring community based society to capitalist, competitive,
            jealousy; Are we progressing or regressing?
        </Text>

        <Text>
            <br />
            Our vision, mission, and activities are centered on creating a conducive space where individuals,
            particularly future generations, can explore their potential freely without being held back by
            any factor.
            A space where, each person can take a step towards one&apos;s wellbeing consistently,
            while naturally creating a meaningful impact on others and supporting their journeys as well.
        </Text>
    </Box>
</Box>)

export const schoolPageIntroduction = (<Box
    width={{ base: "100%", lg: "35vw" }}
    maxW={{ base: "100%", lg: "40rem" }}
    pr={"3rem"}
    paddingTop={{ base: headingSecondaryFont, lg: "0" }}>
    <Text fontSize={headingPrimaryFont} textAlign={"center"} color={primaryColor}>Home School</Text>
    <Box textAlign={"justify"} color={secondaryColorTwo}>
        <Box textAlign={"center"} >
            <Box as='i'>
                Our Syllabus?
                <br />
                Quite simple Really
                <br />
                Just a line. <br />
                "Who am I?"
            </Box>
        </Box>

        <Text>
            <br />
            Our relation lasts only till we graduate, and beyond that? <br />
            Now, Who knows?
            <br /> <br />
            The world is becoming dangerously polarized, fragmentary in nature, with unsustainable practices.
            <a href="https://consciousplanet.org/en/save-soil" target="_blank" >
                <Box textAlign="center" color={primaryColor}> Our soil health is prime example of this. </Box>
            </a> <br />
            <Box textAlign={"center"}> As the saying goes "Reach & touch the sky while being firmly rooted." </Box>
            As showcased in our history, what is education if not understanding, carefully witnessing the
            inclusive nature of the existence and our being?
            <Author />
        </Text>

        <Text>
            <br />

        </Text>
    </Box>
</Box>)

const libraryOneArticle = (<>
    <Text>
        From time immemorial, extraordinary importance has been attached for the act of reading. Irrespective of race, caste, creed, religion
        ideology and language etc education starts with letters in order to construct words and sentences in order to establish a pattern which
        is considered as meaning of the sounds, but what for?
    </Text>
    <Text textAlign={"center"}>
        To express, project the inward movements out to the world? May be so!
    </Text>
    <br />
    <Text>
        The importance of communication in the world is undeniable fact beyond a certain point. A child is taken care off till the age but later on
        he or she has to communicate in order to survive, thus starts the drilling of patterns into young tender minds that ardently refuses to fit in!
        but as the vibrancy is chipped away like a natural phenomenon, mind starts to fit in a mould.
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        yes reading is a great tool in order to learn, communicate and express but is it limited to the pattern?
    </Text>
    <br />
    <Text>
        A dull mind settles to the pattern, but the vigours mind can't help itself but wonder what's  beyond! True, a pattern equips the mind with
        necessary ingredients to express itself for various survival actions but it doesn't answer the question of how these patterns were woven?
        because the pattern, the language itself is not the meaning, it's just a tool for expressing inner movements.
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        As the inner movements grow in its complications, the meaning, the language itself becomes fuzzy! isn't it? There's little or no misunderstanding
        when the expression of human originates from survival aspects of life like hunger, physical pain and needs or need for respect to a certain extent
        but man oh man, beyond these, there are whole bunch of pandora boxes!
    </Text>
    <br />
    <Text>
        Emotions such as pride, happiness, sadness, love and the mother of all the confusions the ego and meaning of life. who can define these complicated
        inner movements in a set of pattern? Sure they have been philosophised  but that's about it.
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        Most people are touched and jolted to something indescribable mostly  by artistic works than philosophies, is it coincidence? perhaps not don't you
        think? The stories that seems to be incomplete, left to one's imagination strikes the chords, living inside us making a impact than a sentence ascribing to
        be meaning in dictionary! True it is important to learn to fit in to an extent but why limited by these patterns?
    </Text>
    <br />
    <Text>
        Once we pass the horizon of survival aspects, the process of reading acquires a whole different quality! An awareness that meanings were given to the
        words by inner movements and the understanding of the inner realm is not in expressing but in experience. Philosophy is a great intermediary tool but understanding of the complicated human emotions doesn't happen from the patterns of philosophical expressions
        but by the sophisticated practice of stillness!
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        In the process of life after churning for a various things begetting, entangling inner movements, now
        its time to wait for the disturbances to settle down and the surface to be unmuddled.
    </Text>
    <br />
    <Box textAlign={"center"} as="i" color={secondaryColorTwo}>
        <Text>Reading is that wonderful omni-purpose tool of utilization;</Text>
        <Text>churn the inner dimension,</Text>
        <Text>indicator to wait</Text>
        <Text>a mirror to the self.</Text>
    </Box>
</>)


export const libraryMainBlog = {
    "id": "one",
    "groupId": "library",
    "title": libraryBlogTitle.one,
    "image": read,
    "imageAlt": "PlaceHolder",
    "body": {
        "title": "LIBRARY - Life Is Beautiful in Reality And Realizing Yourself",
        "content": libraryOneArticle,
        "shortContent": `From time immemorial, extraordinary importance has been attached for the act of reading. 
        Irrespective of race, caste, creed, religion ideology and language etc education starts with letters in order to construct words and sentences in order
         to establish a pattern which is considered as meaning of the sounds, but what for? (Meaning is a pattern)
         \n \n \n
         To express or project the inward movements out to the world? May be so! 
         `
    },
    "footer": "Read",
    "href": libraryHref.one,
    "isArticle": false,
    "isInitiallyOpen": false,
    "previous": {
        "href": missionBlogHref.three,
        "title": missionBlogTitle.three
    },
    "next": {
        "href": yogaHref.one,
        "title": yogaBlogTitle.one
    }
}

const whyYoga = (<Box color={secondaryColorTwo} >
    <Text color={primaryColor}>Why Yoga?</Text>
    <Text>
        is not the question, Why not Yoga? is the question.
    </Text>
    <Text>
        We don&apos;t let this grow in us! but there&apos;s always a thought, feeling, emotion in the background that
    </Text>
    <Text textAlign={"center"} color={primaryColor}>
        &quot;nothing truly satisfies me&quot;
    </Text>
    <Text textAlign={"center"} color={primaryColor}>
        &quot;nobody truly understands me&quot;
    </Text>
    <Text>
        haven&apos;t you been here?
    </Text>
    <Text>
        This is neither to be ignored, nor to be flaunted, but to be with!
        For one&apos;s own growth; And now yoga...
    </Text>
</Box>)

const yogaMainBlogContent = (<Box>
    <Text>
        In current times considering the state of human predicament, direction of the society,
        it is easy to define, communicate what YOGA is not, rather than attempting to define what YOGA is.
        Any attempt to define YOGA would be like searching for a number that&apos;s infinite. When human,
        an individual state of mind is such that it is only concerned with the number, counting slightly
        higher number than they come across; What is the point of defining infinity? but as long as Life
        exists, human consciousness will not settle.
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        Whether one is aware or not, able to handle it or not, desires it or not, life does not care!
        Consciousness in various ways drives the life towards the infinite and life propagates that drive
        to the field of mind in innumerable forms. In the form of desire, jealousy, greed, envy, pride,
        arrogance, ambition to name a few. One is successful in the society when they have more money,
        bigger home, better car or slightly richer than their neighbors. In most of the humans life the only
        purpose or aspect of living is being better than someone else, utmost being better than their past
        self, but comparison has become inevitable.
    </Text>
    <br />

    <Text>
        When the mind is questioning only from the point of comparison, is it not better and effective
        to say no, rather than attempting to convey that comparison is not the way? There is no way
        life would let the mind be stuck at comparison forever anyway, hence there is no way seeking
        would stop, so till thers is an evolution till the point where a individual perceives the limitation
        of mind, it becomes rather very important to entertain the mind, which otherwise feels subjugated,
        oppressed. A patient &quot;no&quot; is important.
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        It is of great importance, relavence and urgent to address what YOGA is not. In the world of economics,
        where the word &quot;profit&quot; has become the only metric, the word &quot;YOGA&quot; has become a
        new business for cashing in little more money than the other. While it being used as such, &quot;YOGA&quot;
        is no business, &quot;YOGA&quot; is no label that is being put on age old trade of acrobatics, physical
        exercises, breathing exercise or fitness industry. &quot;YOGA&quot; is no maketing strategy for gaining customers.
        &quot;YOGA&quot; is no method for achieving spot light, recognition. &quot;YOGA&quot; is no way for becoming
        famous, rich or successful than the other. &quot;YOGA&quot; is no demostration of blind fold reading, driving or
        bending spoons. &quot;YOGA&quot; is no special ability or a circus trick. &quot;YOGA&quot; is no way of becoming
        better than somebody or oneself for that matter; So Why YOGA?
    </Text>
    <br />
    {whyYoga}
    <br />
    <Text>
        Yoga is no number, it is infinite. In culture and tradition the literal representation and the
        translation would be &quot;union&quot;, becoming infinite from being one or two. While there are
        many ways and practices to experience &quot;YOGA&quot;, it is wise not to put a definition on the
        experience; it is very important to keep the knowledge of the possibility alive. This is important,
        to preserve this shard of compassion for those who acknowledge the limitation of mind and confront
        the scathing and wrenching pain of ignorance.
    </Text>
    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        Though everyone keeps playing blind eye to the obvious questions, at some point in time an individual
        can not ignore the basis and the fragile nature of one&apos;s own existence. An individual will have
        to come face to face with questions and the facts that is been taken for granted, that
    </Text>
    <Text textAlign={"center"} color={secondaryColorTwo}>
        <br />
        we don&apos;t know the source of our own breath that keeps us alive <br />
        we don&apos;t know who we are when we are asleep <br />
        we don&apos;t know what happens when body&apos;s time is up <br />
    </Text>
    <br />
    <Box>
        An individual has to face them, which is each and every one of us but in a different point of time.

    </Box>
    <Tooltip label="Click">
        <Text as="a" href={"https://isha.sadhguru.org/yoga/new-to-yoga/what-is-yoga/"}
            color={primaryColor}
            target="_blank">
            So what is yoga? Read on ...
        </Text>
    </Tooltip>
</Box>)

export const yogaMainBlog = {
    "id": "one",
    "groupId": "yoga",
    "title": yogaBlogTitle.one,
    "image": meditation,
    "imageAlt": "PlaceHolder",
    "body": {
        "title": "YOGA - Your Only Guide is Awareness",
        "content": yogaMainBlogContent,
        "shortContent": whyYoga
    },
    "footer": "Read",
    "href": yogaHref.one,
    "isArticle": false,
    "isInitiallyOpen": false,
    "previous": {
        "href": libraryHref.one,
        "title": libraryBlogTitle.one
    }
}


export const libraryPageIntroduction = (<>
    <Box
        width={{ base: "100%", lg: "35vw" }}
        maxW={{ base: "100%", lg: "40rem" }}
        pr={"3rem"}
        paddingTop={{ base: headingSecondaryFont, lg: "0" }}>

        <Text fontSize={headingPrimaryFont} textAlign={"center"} color={primaryColor}>Life Is Beautiful in Reality And Realizing Yourself</Text>
        <Box textAlign={"justify"} color={secondaryColorTwo}>
            <Box textAlign={"right"} >
                <ItalicText> ~~~ LIBRARY</ItalicText>
            </Box>
            <br />
            <Text color={primaryColor} fontSize={secondaryFontSize}>Why Read?</Text>
            <Text>
                The Books are Kalpataru of the material world, mirror of the inner dimension, the bridge and the platform for the life to dance and find expression.
            </Text>
            <Author />
        </Box>
    </Box>
</>)

export const yogaPageIntroduction = (<>
    <Box
        width={{ base: "100%", lg: "35vw" }}
        maxW={{ base: "100%", lg: "40rem" }}
        pr={"3rem"}
        paddingTop={{ base: headingSecondaryFont, lg: "0" }}>

        <Text fontSize={headingPrimaryFont} textAlign={"center"} color={primaryColor}>Your Only Guide is Awareness</Text>
        <Box textAlign={"justify"} color={secondaryColorTwo}>
            <Box textAlign={"right"} >
                <ItalicText> ~~~ YOGA</ItalicText>
            </Box>
            <br />
            <Text color={primaryColor} fontSize={secondaryFontSize}>Why Yoga?</Text>
            <Box>
                is not the question, Why not Yoga? is the question.
                <Box>
                    We don&apos;t let this grow in us! but there&apos;s always a thought,
                    feeling, emotion in the background that
                    <Box color={primaryColor} textAlign={"center"}>
                        &quot;nothing truly satisfies me&quot;
                    </Box>
                    <Box color={primaryColor} textAlign={"center"}>
                        &quot;nobody truly understands me&quot;
                    </Box>
                    haven&apos;t you been here?
                    <br />
                    This is neither to be ignored, nor to be flaunted,
                    but to be with!
                    <br />
                    For one&apos;s own growth; And now yoga...
                </Box>
            </Box>
            <Author />
        </Box>
    </Box>
</>)

export const hathaYogaPageIntroduction = (<>
    <Box
        width={{ base: "100%", lg: "35vw" }}
        maxW={{ base: "100%", lg: "40rem" }}
        pr={"3rem"}
        paddingTop={{ base: headingSecondaryFont, lg: "0" }}>

        <Text fontSize={headingPrimaryFont} textAlign={"center"} color={primaryColor}>Classical Hatha Yoga</Text>
        <Box textAlign={"justify"} color={secondaryColorTwo}>
            <br />
            <Box>
                The body is a very large part of who we are right now.
                The science of using the body to hasten one&apos;s evolutionary process is hatha yoga.
                Health and fitness are just the side-benefits of Hatha Yoga.
                Classical Hatha Yoga is a powerful system to prepare the human system to explore our full potential.
            </Box>
            <br />
            <Text>
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                Dedicating a certain amount of effort and time to see that the body does not
                become a barrier is important, hence Hatha Yoga.
            </Text>
            <Author></Author>
        </Box>
    </Box>
</>)

export const nadaYogaPageIntroduction = (<>
    <Box
        width={{ base: "100%", lg: "35vw" }}
        maxW={{ base: "100%", lg: "40rem" }}
        pr={"3rem"}
        paddingTop={{ base: headingSecondaryFont, lg: "0" }}>

        <Text fontSize={headingPrimaryFont} textAlign={"center"} color={primaryColor}>Nada Yoga</Text>
        <Box textAlign={"justify"} color={secondaryColorThree}>
            <Box>
                Yoga describes the human being as a physical and subtle system of prāṇa and nāḍīs.
                Classical texts such as the Dhyāna-bindu Upaniṣad and Haṭha Yoga Pradīpikā speak of 72,000 nāḍīs,
                with iḍā, piṅgalā, and suṣumṇā as the principal channels.
            </Box>

            <Box>
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                The number 108 has deep significance in yogic traditions.
                The contemporary yogic understanding of 114 energetic junctions, with 112 within the body and 108
                as significant active centers, expands upon this classical subtle-body framework.
            </Box>
            <br />
            The yogic tradition regards Sanskrit sounds as fundamental expressions of śabda,
            while the Nāda-bindu Upaniṣad describes nāda, the inner sound, as a means of transcending the mind and
            realizing the soundless.
            <Box>
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                This use of sound as a means of transforming and evolving the human system is known as Nāda Yoga.
            </Box>
        </Box>
    </Box>
</>)

export const bhakthiYogaPageIntroduction = (<>
    <Box
        width={{ base: "100%", lg: "35vw" }}
        maxW={{ base: "100%", lg: "40rem" }}
        pr={"3rem"}
        paddingTop={{ base: headingSecondaryFont, lg: "0" }}>

        <Text fontSize={headingPrimaryFont} textAlign={"center"} color={primaryColor}>Bhakthi Yoga</Text>
        <Box textAlign={"justify"} color={secondaryColorTwo}>
            <Box>
                In Yoga they say as there is physical body there is energy body
                made up of  72,000 nadis which meet and redistribute in 114 significant ways or there is 114
                junction boxes in the human system, of these 2 are outside the physical nature and 112 are within.
                Out of these 112, four are dormant to a large extent so 108 are active energy centers in the body
                or chakras.
            </Box>

            <Box>
                &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                These 108 are divded on the right and the left in the form of ida and pingala, they are divded as
                54 each, based on this sankrit alphabets of 54 sounds are formed. These 54 sounds in 2 manifestations of
                feminine and masculine amounting to 108 has a significance and the whole music system evolved out of these 108.
            </Box>
            <br />
            This dimension of activating the human system, this dimension of allowing the human system to evolve
            to its ultimate possibility by using these 108 sounds is called nada yoga.
            <Author>Sadhguru</Author>
        </Box>
    </Box>
</>)

const sharathExperienceModel = (
    <>
        <Text textAlign={"justify"} color={"#6D6358"}>
            As i anguished the strangling subjective boundries of the limited perception, Inner Enggineering came like a natural phenomenon,
            akin to a season for the flowers to  bloom.
        </Text>

        <Text textAlign={"justify"} color={"#6D6358"}>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            Though i knew it was rope in the dark, the fear of snake remained until the light was dawned on it.
        </Text>
        <br />
        <Text textAlign={"justify"} color={"#6D6358"}>
            Though it is obvious that the life stems from the objective, progressing through the subjective and ultimately culminating where it all began,
            the mind struggled to come to terms with it being torn apart by the subjective boundries; Inner Enggineering is a way of liting a lamp to see that
            its not life and death but birth, living and death are nothing but a phases of life;
            its not consciousness and perception but clarity, stability and perception are the phases of consciousness.
        </Text>
    </>
)

export const iEExperiences = [{
    "img": me,
    "imgAlt": "Sharath",
    "title": "Sharath",
    "subtitle": "Software Engineer",
    "shortContent": "\"As i anguished the strangling subjective boundries of the limited perception, Inner Enggineering came like a natural phenomenon, akin to a season for the flowers to  bloom.\"",
    "content": `Though it is obvious that the life stems from the objective, progressing through the subjective and ultimately culminating where it all began,
                the mind struggled to come to terms with it being torn apart by the subjective boundries; Inner Enggineering is a way of liting a lamp to see that
                its not life and death but birth, living and death are nothing but a phases of life;
                its not consciousness and perception but clarity, stability and perception are the phases of consciousness.`,
    "hoverTitle": "Read More",
    "modelHeader": "#MyInnerEngineering Experience",
    "modelContent": sharathExperienceModel
}]

const roopaIntroeModel = (
    <>
        <Text textAlign={"justify"} color={"#6D6358"}>
            I aim to be a dynamic and thoughtful individual who stays actively engaged in all
            aspects of life.
            My thinking and actions are consciously aligned, to be involved, curious, and continuously learning.
        </Text>

        <Text textAlign={"justify"} color={"#6D6358"}>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            More than just education or qualifications, I enjoy meaningful interactions, personally, professionally,
            and humanely. I value creating a comfortable space where people feel heard, understood, and connected.
        </Text>
        <br />
        <Text textAlign={"justify"} color={"#6D6358"}>
            I value living consciously, learning continuously, and contributing positively in order to
            understand how the quality of life is defined and what truly makes life worth it.
            As a child, I had the freedom to explore, play, express, and experience life fully.
            Today, I often reflect on how modern lifestyles and limited social environments can restrict
            that kind of growth in children.
            These reflections have shaped my desire to create spaces where learning and joy coexist irrespective
            of career and direction.
        </Text>
    </>
)

const roopaTitleIcon = (
    <NavigatableIcon
        size={24}
        icon={ImLinkedin}
        color='#0077B5'
        label="Connect"
        href="https://www.linkedin.com/in/dr-roopa-j-a2618188/" />
)

const jagadishIntroeModel = (
    <>
        <Text textAlign={"justify"} color={"#6D6358"}>
            ⁠I see yoga not merely as a practice but as a framework for cultivating an intelligence quieter
            and steadier than the noise of everyday life.
        </Text>

        <Text textAlign={"justify"} color={"#6D6358"}>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            I join this in swadharma, my focus is helping build something collective
            and enduring: a space where people can re-anchor, find clarity,
            and learn to live fully.
        </Text>
        <br />
        <Text textAlign={"justify"} color={"#6D6358"}>
            I am the founder of CITTAM SYSTEMS, named for chitta, the field of mind that yoga works upon, and I build
            tools in that same spirit: creating conditions for people to discover the intelligence already within them.
        </Text>
    </>
)

const praveenIntroeModel = (
    <>
        <Text textAlign={"justify"} color={"#6D6358"}>
            I am an Electrical ⁠engineer by profession holding M.S. in Electrical Engineering from the
            University of Texas at Dallas and a B.E. in Electronics and Communication from PES University.
            I live and work in the United States for the past 15 years now.
        </Text>

        <Text textAlign={"justify"} color={"#6D6358"}>
            &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
            I spend my days designing chips to run at their peak without burning out
            for years now. Yet, over time, I realized I wasn&apos;t asking the same question about myself.
            After Thirteen years in semiconductor design at Apple and Intel has taught me what sustained pressure does
            to a person and I took to a path of yoga not merely as a practice of physical well-being, but as a path
            toward greater awareness, resilience, and balance.
        </Text>
        <br />
        <Text textAlign={"justify"} color={"#6D6358"}>
            It is from this personal journey that I engage with Swadharma Spandana at my personal capacity
            with intention to create a space where curiosity is encouraged, lived experience is valued over
            unquestioned authority, and learning emerges through exploration rather than adherence to rigid or
            burdensome theories. I believe meaningful growth comes not from idolizing ideas or individuals, but
            from discovering what resonates through direct experience and thoughtful inquiry.
        </Text>
    </>
)

const jagadishTitleIcon = (
    <NavigatableIcon
        size={24}
        icon={ImLinkedin}
        color='#0077B5'
        label="Connect"
        href="https://www.linkedin.com/in/cittam/" />
)

const praveenTitleIcon = (
    <NavigatableIcon
        size={24}
        icon={ImLinkedin}
        color='#0077B5'
        label="Connect"
        href="https://www.linkedin.com/in/praveen-kumar-r-9108b940/" />
)


export const TeamMembersIntro = [{
    "img": me,
    "imgAlt": "Sharath",
    "title": "Sharath",
    "subtitle": "MS University of Auckland",
    "shortContent": "The Manifestation is my mother, The Unmanifestation my father, \n while the commited and devoted people are my family.",
    "content": ``,
    "hoverTitle": "Read More",
    "href": "/blog/sharath"
},
{
    "img": roopa,
    "imgAlt": "roopa",
    "title": "Dr. Roopa J",
    "titleIcon": roopaTitleIcon,
    "subtitle": "Post Doc, IISc, CeNSE",
    "shortContent": "More than just education or qualifications, I see myself as someone who enjoys meaningful interactions, personally, professionally, and humanely.",
    "content": '',
    "hoverTitle": "Read More",
    "modelContent": roopaIntroeModel
},
{
    "img": manju,
    "imgAlt": "manjushri",
    "title": "Manjushri",
    "subtitle": "",
    "shortContent": "In the movement of learning and observing, on a journey to realise the learner and the observer.",
    "content": ``,
    "hoverTitle": "Read More",
    "modelContent": ""
},
{
    "img": jagadeesh,
    "imgAlt": "Jagadish Kumar",
    "title": "Jagadish Kumar",
    "titleIcon": jagadishTitleIcon,
    "subtitle": "Founder AT CITTAM SYSTEMS",
    "shortContent": "My focus is helping build something collective and enduring: a space where people can re-anchor, find clarity, and learn to live fully.",
    "content": ``,
    "hoverTitle": "Read More",
    "modelContent": jagadishIntroeModel
},
{
    "img": praveen,
    "imgAlt": "Praveen Kumar",
    "title": "Praveen Kumar",
    "titleIcon": praveenTitleIcon,
    "subtitle": "Sr.Pixel IP Design Engineer | Apple",
    "shortContent": "I spend my days designing chips to run at their peak without burning out for years now. Yet, over time, I realized I wasn't asking the same question about myself.",
    "content": ``,
    "hoverTitle": "Read More",
    "modelContent": praveenIntroeModel
}
]

export const lifeActivitiesCards = [{
    "img": spreadingjoy,
    "imgAlt": "OurInitiatives",
    "title": "Our Initiatives",
    "subtitle": "",
    "shortContent": "Our initiatives and activities both aim to bring the community together and support individual and collective wellbeing.",
    "content": ``,
    "hoverTitle": "Read More",
    "modelContent": "",
    "href": routes.u2l
},
{
    "img": profession,
    "imgAlt": "Professional Development",
    "title": "Professional Development",
    "subtitle": "Support",
    "shortContent": "A way to explore the term Profession from various perspectives, with the ultimate goal of having a taste of wellbeing and fullfillment.",
    "content": ``,
    "hoverTitle": "Read More",
    "href": routes.pdSupport
},
{
    "img": blossomIntoInnerFreedom,
    "imgAlt": "LearnToBlossomIntoInnerFreedom",
    "title": "Learn",
    "subtitle": "Blossoming Into Inner Freedom",
    "shortContent": "To Learn is to be fully aware in the moment, even of the consequences of past & projections of the future that lives in this moment, and give them their appropriate place in oneself consciously.",
    "content": '',
    "hoverTitle": "Read More",
    "href": routes.learn
}]




const yogastha = (
    <Box ml={"4.5rem"}>
        <Text>योगस्थः कुरु कर्माणि</Text>
        <Text>सङ्गं त्यक्त्वा धनञ्जय ।</Text>
        <Text>सिद्ध्यसिद्ध्योः समो भूत्वा</Text>
        <Text>समत्वं योग उच्यते ॥</Text>
    </Box>
)

const yogasthaTranslation = (
    <Box textAlign={"center"} mb={0}>
        <Text >Established in yoga, perform action</Text>
        <Text >abandoning attachment;</Text>
        <Text >remaining equal in success and failure,</Text>
        <Text >this equanimity is called yoga.</Text>
    </Box>
)

const yogasthaContent = (
    <Flex direction={"column"}>
        <Box mb={{ base: "0", md: "1rem" }}>
            {yogastha}
        </Box>
        <Box>
            {yogasthaTranslation}
        </Box>
    </Flex>
)

export const LearningProgramme = [
    {

        "img": profession,
        "imgAlt": "PD Support",
        "title": "Professional",
        "subtitle": "Development Support",
        "shortContent": "A way to explore the term Profession from various perspectives, with the ultimate goal of having a taste of wellbeing and fullfillment.",
        "content": ``,
        "hoverTitle": "Read More",
        "href": routes.pdSupport
    },
    // {
    //     "card": {
    //         "img": read,
    //         "imgAlt": "Learn",
    //         "title": "Learn Skills",
    //         "subtitle": "Start Where You Left!",
    //         "shortContent": "It's a myth that learning ends, our mission is to nurture a environment where learning paves the path to come together and explore life in its entirety.",
    //         "content": ``,
    //         "hoverTitle": "Read More"
    //     },
    //     "href": "/learn"
    // }
    {

        "img": meditation,
        "imgAlt": "Yoga",
        "title": "Yoga",
        "subtitle": "SwaDharma Spandana",
        "shortContent": yogasthaContent,
        "content": `something`,
        "hoverTitle": "Read More",
        "href": "/learn/yoga"
    },
    // {
    //     "card": {
    //         "img": samaskriti,
    //         "imgAlt": "Cultural",
    //         "title": "Cultural",
    //         "subtitle": "Indian Clasical Arts",
    //         "shortContent": "",
    //         "content": ``,
    //         "hoverTitle": "Read More"
    //     },
    //     "href": "/learn/cultural-arts"
    // },
    {

        "img": read,
        "imgAlt": "Library",
        "title": "Library",
        "subtitle": "Worth a read!",
        "shortContent": "In the age of social media, instant gratification is the norm, the books are a great companion for a slower, thoughtful, and sensitive life.",
        "content": ``,
        "hoverTitle": "Read More",
        "href": routes.library
    },

]


export const CulturalLearningProgramme = [{
    "card": {
        "img": read,
        "imgAlt": "Learn",
        "title": "Music",
        "subtitle": "Start Where You Left!",
        "shortContent": "The Education ",
        "content": `som`,
        "hoverTitle": "Read More"
    },
    "href": ""
}, {
    "card": {
        "img": spreadingjoy,
        "imgAlt": "Gita",
        "title": "Gita",
        "subtitle": "Development Support",
        "shortContent": "The Education ",
        "content": ``,
        "hoverTitle": "Read More"
    },
    "href": routes.pdSupport
}, {
    "card": {
        "img": spreadingjoy,
        "imgAlt": "Yoga",
        "title": "Yoga",
        "subtitle": "Development Support",
        "shortContent": "The Education ",
        "content": ``,
        "hoverTitle": "Read More"
    },
    "href": routes.pdSupport
}]

export const libraryWeHaveBooks = (<Box
    width={{ base: "100%", lg: "40vw" }}
    maxW={{ base: "100%", lg: "50rem" }}
    h={{ base: "16rem", lg: "20rem" }}
>
    <Box className="heading" mt="1rem">
        <Heading color={primaryColor} textAlign={"center"} pb={"1rem"}>We Have Books!</Heading>
    </Box>

    <Box textAlign={"justify"} color={secondaryColorTwo} h={{ base: "10rem" }} alignContent="center" overflow={"scroll"} >
        <Text>
            yeah, Of All sorts. Children stroy books, Novels, a few Professional Academic one's, Self Help and of course Spiritual books.
        </Text>

        <Text>
            &nbsp; &nbsp; &nbsp; &nbsp; we have a small, quite reading space for you to pick any of the book and immerse yourself into it.
            It's also allowed to take books with you on individual basis after checking with the admin
            <br />
            <br />
            We organise reading sessions as well, please contact admin for more details.
        </Text>
    </Box>
</Box>)

export const libraryWeAcceptBooks = (<Box
    width={{ base: "100%", lg: "40vw" }}
    maxW={{ base: "100%", lg: "50rem" }}
    h={{ base: "16rem", lg: "20rem" }}
>
    <Box className="heading" mt="1rem">
        <Heading color={primaryColor} textAlign={"center"} pb={"1rem"}>Still We Collect Books!</Heading>
    </Box>

    <Box textAlign={"justify"} color={secondaryColorTwo} h={{ base: "10rem" }} alignContent="center" overflow={"scroll"} >
        <Text>
            As the saying goes "Half knowledge is dangerous" and the cure for it is not ignorance but more knowledge!
        </Text>

        <Text>
            &nbsp; &nbsp; &nbsp; &nbsp; We take in any books that you think is worthy of attention and spreads good will
            in society; of course it has to be in a readable condition.
        </Text>
        <br />
        <Text >
            Please drop the books to us personally or mail it to our
            <Box as='a' href={`${routes.library}#contactUs`} color={primaryColor}> location.</Box>
        </Text>
    </Box>
</Box>)

export const genericLearningPageIntroduction = (<>
    <Box
        width={{ base: "100%", lg: "35vw" }}
        maxW={{ base: "100%", lg: "40rem" }}
        pr={"3rem"}
        paddingTop={{ base: headingSecondaryFont, lg: "0" }}>

        <Text fontSize={headingPrimaryFont} textAlign={"center"} color={primaryColor}>
            To Learn one must have Humility;
        </Text>
        <Box textAlign={"justify"} color={secondaryColorTwo}>
            <br />
            <Text>
                To Learn Mind must be in a state of not knowing. Not knowing is the essence of Humility.
                A Mind which has accumulated knowledge which knows, has no Humility. It is only the Mind
                that has Humility that Learns, and therefore the Humility never accumulates.
            </Text>
            <Author > J. Krishnamurti </Author>
        </Box>
    </Box>
</>)

export const choiceOfAWisePoem = (<>
    <Box
        width={{ base: "100%", lg: "35vw" }}
        maxW={{ base: "100%", lg: "40rem" }}
        pr={"3rem"}
        paddingTop={{ base: headingSecondaryFont, lg: "0" }}>

        <Text fontSize={headingPrimaryFont} textAlign={"center"} color={primaryColor}>
            A Choice of a Wise
        </Text>
        <Box textAlign={"justify"} color={secondaryColorTwo}>
            <br />
            <Flex justifyContent={"space-between"} >
                <Text textAlign={"center"}>
                    When all that matters is the fruit,
                    <br />
                    not the root;
                    <br />
                    Everyone wants to relish the fruit.
                    <br />
                    <br />
                    The smart climbs the tree,
                    <br />
                    may or may not taste the fruit,
                    <br />
                    may or may not share the fruit.
                    <br />
                    <br />
                    A fool throws a stone,
                    <br />
                    may or may not strike the fruit,
                    <br />
                    might strike the man or himself;
                    <br />
                    desperately or accidentally.
                    <br />
                    <br />
                </Text>
                <Text textAlign={"center"}>
                    The wise may or may not
                    <br />
                    taste the fruit,
                    <br />
                    but at the least are never struck,
                    <br />
                    for the choice that was made,
                    <br />
                    the root over the fruit.
                    <br />
                    <br />
                    And in time,
                    <br />
                    surely,
                    <br />
                    someone will taste the fruit.
                </Text>
            </Flex>
            <Author />
        </Box>
    </Box>
</>)

export const independentThinkingAndIndividualDevelopment = (
    <>
        <Text>
            It&apos;s a norm where a child is told what to do, what to be, or at best they get influenced by the
            environment they are in.
        </Text>

        <Text>
            &nbsp; &nbsp; &nbsp; &nbsp; The child slowly stops asking questions, stops wondering and starts to
            imitate, and in the day and age of social media, Artificial Intelligence, the world is losing Individuality.
            <br />
            We focus on reigniting the spark of wonder needed to explore life not just career, in a holistic way.
        </Text>
    </>)

export const individualAndProfessionalDevelopment = (<>
    <Text>
        Why is the profession being defined and driven by the capitalists and not the individual?
    </Text>

    <Text>
        &nbsp; &nbsp; &nbsp; &nbsp; Who is defining the business values in the economy? How is it contributing
        to the human wellbeing?
    </Text>
    <br />
    <Text >
        We aim to bring fresh perspective on business values to ensure we do not leave the next generation
        deprived of what is not even ours.
    </Text>
</>)


export const pdWorkShops = [{
    "img": individualDevelopment,
    "imgAlt": "Independent Thinking & Individual Development!",
    "title": "Independent Thinking & Individual Development!",
    "subtitle": "Workshop",
    "shortContent": "We focus on reigniting the spark of wonder in child that is needed to explore life not just career, in a holistic way.",
    "hoverTitle": "Read More",
    "modelContent": independentThinkingAndIndividualDevelopment
},
{
    "img": professionalDevelopment,
    "imgAlt": "Individual & Professional Development!",
    "title": "Individual & Professional Development!",
    "subtitle": "Workshop",
    "shortContent": "Why is the profession being defined and driven by the capitalists and not the individual?",
    "hoverTitle": "Read More",
    "modelContent": individualAndProfessionalDevelopment
}]

export const professionDevelopmentPageIntroduction = (<>
    <Box
        width={{ base: "100%", lg: "35vw" }}
        maxW={{ base: "100%", lg: "40rem" }}
        pr={"3rem"}
        paddingTop={{ base: headingSecondaryFont, lg: "0" }}>

        <Text fontSize={headingPrimaryFont} textAlign={"center"} color={primaryColor}>
            PROFESSION
        </Text>
        <Box textAlign={"justify"} color={secondaryColorTwo}>
            <br />
            <Text>
                The root words of the profession, &quot;professio&quot;
                which originally meant a public declaration or commitment and &quot;Fateri&quot;, this root is
                important because it underscores the idea of a conscious commitment or acknowledgment of
                one&apos;s chosen path or calling.
                <br />
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                Professionalism is the abstraction or a word representating the state of deep involvment
                begot by the unwavering commitment to the process in a direction, by exercising one&apos;s
                will to the highest level possible.
            </Text>
            <br />
            <Author />
        </Box>
    </Box>
</>)

export const professionLevel1 = (<Box
    width={{ base: "100%", lg: "40vw" }}
    maxW={{ base: "100%", lg: "50rem" }}
    h={{ base: "16rem", lg: "20rem" }}
>
    <Box className="heading" mt="1rem">
        <Heading color={primaryColor} textAlign={"center"} pb={"1rem"}>Finding a Start Line!</Heading>
    </Box>

    <Box textAlign={"justify"} color={secondaryColorTwo} h={{ base: "10rem" }} alignContent="center" overflow={"scroll"} >
        <Text as='a' href='/blog?id=vision_three'>
            We organise a interactive and fun learning sessions for school children and adults to explore the idea
            of Profession and Professionalism.
        </Text>
        <br />

        <Text>
            &nbsp; &nbsp; &nbsp; &nbsp; In our mission to establish a community to nurture life in existentiality,
            we engage with both children and adults. we aim to be part of the story of the children on
            the cusp of choosing career as a profession and, adults who wants to lead a impactful life with
            a profound experience of life
        </Text>
    </Box>
</Box>)

export const professionLevel2 = (<Box
    width={{ base: "100%", lg: "40vw" }}
    maxW={{ base: "100%", lg: "50rem" }}
    h={{ base: "16rem", lg: "20rem" }}
>
    <Box className="heading" mt="1rem">
        <Heading color={primaryColor} textAlign={"center"} pb={"1rem"}>Mid Career Professional Career Support</Heading>
    </Box>

    <Box textAlign={"justify"} color={secondaryColorTwo} h={{ base: "10rem" }} alignContent="center" overflow={"scroll"} >
        <Text>
            While we always encourage deeper contemplation on the idea of profession we also understand the
            importance of work in the fabric of society.
        </Text>

        <Text>
            &nbsp; &nbsp; &nbsp; &nbsp; We try to organise our work in such a way that when done, it
            becomes a work experience with tangiable  crediblity in the industry for graduates and students
            who are looking for a real world work experience.
            We also actively engage with the like minded industrial organisations in order to create various
            sorts of openings for learners.
        </Text>
    </Box>
</Box>)

export const professionLevel3 = (<Box
    width={{ base: "100%", lg: "40vw" }}
    maxW={{ base: "100%", lg: "50rem" }}
    h={{ base: "16rem", lg: "20rem" }}
>
    <Box className="heading" mt="1rem">
        <Heading color={primaryColor} textAlign={"center"} pb={"1rem"}>
            Graduating From the Idea of Profession.
        </Heading>
    </Box>

    <Box textAlign={"justify"} color={secondaryColorTwo} h={{ base: "15rem" }} alignContent="center" overflow={"scroll"} >
        <Text>
            Profession is a transition from labour to volunterring, from work to play, from earning to giving;
            it&apos;s the blossming of the &quot;will&quot; of commitment to something beyond the compulsions,
            and the idea of self one holds.
            <br />
        </Text>
        <Text color={primaryColor} textAlign={'center'}
        >This is what our ansecstors, our culture ascribed as &quot;Dharma&quot;.</Text>

        <Text>
            Are you ready to find something beyond the image you hold as yourself? We are dedicated to evolve tools for the purpose!
            <Text as={'a'} href='/blog#vision' color={"#2c43f5"}> Read More...</Text>
        </Text>
        <Text>
            &nbsp; &nbsp; Or do you think you have already found it? Then we are sure we will have a story
            to share together inline with our mission! Write to us...
        </Text>
        <br />
    </Box>
</Box>)


